import axios from './rest-axios';

const getDrkb = (date) => axios.get(`/manage/drkb`, {date});

export {
    getDrkb,
}